import { gql } from '@apollo/client';

export const DELETE_SEGMENT_MUTATION = gql`
    mutation deleteSegment($id: UUID!) {
        result: deleteSegment(id: $id) {
            affectedRows
        }
    }
`;
